import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { fetchAds } from '../../store/actions';
import 'react-lazy-load-image-component/src/effects/blur.css';

/**
 * BannerSection Component
 * Fetches and displays a horizontal banner ad (size 729x90) in the specified section.
 */
const BannerSection = ({ className, fetchAds, adsCategory }) => {
    useEffect(() => {
        // Fetch ads if adsCategory is empty
        if (adsCategory.length === 0) fetchAds();
    }, [adsCategory, fetchAds]);

    // Get the first ad with size 's729x90' or default to an empty object
    const banner729x90 =
        adsCategory.filter((ad) => ad.size === 's729x90')[0] || {};

    return (
        <div className={`${className || 'padding2020 '}`}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 m-auto">
                        <div className="banner-section">
                            <a
                                href={banner729x90.link}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {banner729x90.image &&
                                    banner729x90.image.length > 0 && (
                                        <img
                                            src={
                                                process.env.REACT_APP_CMS_URL +
                                                banner729x90.image[0].url
                                            }
                                            alt="banner"
                                            effect="blur"
                                            className="horizontal-banner"
                                        />
                                    )}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

/**
 * Maps the Redux state to props for the component.
 * Filters ads to include only those with the position 'bannerSection'.
 */
const mapStateToProps = (state) => {
    return {
        adsCategory: state.ads.ads.filter(
            (ad) => ad.position === 'bannerSection'
        ),
    };
};

/**
 * Maps the Redux dispatch to props for the component.
 * Provides a method to fetch ads from the store.
 */
const mapDispatchToProps = (dispatch) => {
    return {
        fetchAds: () => dispatch(fetchAds()),
    };
};

// Connect the component to the Redux store
export default connect(mapStateToProps, mapDispatchToProps)(BannerSection);
